module.exports = __webpack_public_path__ + "static/media/recipes.a8b2407e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/elements/screen-images/food/recipes.jpg
// module id = 658
// module chunks = 0